/** A tab label's total, in the job cards' segmented tab control. */
export function JobTabCount({ value }: { value: number | string }) {
  return <span className="font-mono text-[10px] text-muted-foreground">{value}</span>
}
